export const isKZDomain = (host: string) => {
    const domain = host.split(':')[0];
    return domain.endsWith('.kz') || domain.endsWith('.lmkz.tech') || domain.startsWith('kazakhstan.');
};

export const getCountryHref = (location: string, path: string) => {
    const langPrefix = location.startsWith('/kz/') ? '/kz' : '';

    return `${langPrefix}${path}`;
};

export const dispatchEvent = (type: string, detail: unknown) => {
    document.body.dispatchEvent(new CustomEvent(type, { detail }));
};
